import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import { Button } from './ui/button';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container-full">
        <div className="about-content">
          <div className="section-header">
            <h2 className="section-title">Who We Are</h2>
          </div>

          <div className="about-text">
            <p>
              Our clients look to us to augment expertise, navigate complex investment
              decisions, assure compliance, manage integration, lead systems modernization,
              elevate process innovation, and with organizational design change. Our team fosters
              a collaborative environment where decisions must align performance, ethics, and
              purpose without the overhead of larger firms.
            </p>
            <p className="about-emphasis">
              We build capability. Our work turns uncertainty into
              intelligence, complexity into clarity, and governance into a design for progress.
            </p>
          </div>

          <div className="about-signature">
            <h3 className="signature-text">IDO - Adaptive Intelligence. by Design.</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;